import React from 'react';
import Gallerie from './Gallerie';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Calendrier from './Calendrier';
import Localisation from './Localisation';
import PrestationsResume from './PrestationsResume';
import Equipements from './Equipements';
import Tarif from './Tarif';
import PageFAQ from './PageFAQ';



const styles = theme => ({
  root: {
//    flexGrow: 1,
//    backgroundColor: 'red',
    marginLeft: 50,
    marginRight: 50,
    marginTop: 20,
    marginBottom: 20
  },
  paper: {
//padding: theme.spacing.unit * 2,
  //  textAlign: 'center',
  //  color: theme.palette.text.secondary,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 20,
    marginBottom: 20
  },

  paperDescription: {
    padding: theme.spacing.unit * 3,
      //  textAlign: 'center',
      //  color: theme.palette.text.secondary,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 20,
        marginBottom: 20
      },
    
  paperCalendar: {
    padding: theme.spacing.unit * 2,
  },
  description: {
    textAlign: 'left'
  }

});


class Main extends React.Component{
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render(){
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div className={classes.root}>
        <Paper square>
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            <Tab label="Description" />
            <Tab label="Equipements" />
            <Tab label="Tarif" />
            <Tab label="Localisation" />
            <Tab label="FAQ" />
          </Tabs>
        </Paper>
        <br/>

        <Grid container spacing={8}
       //   direction="row"
        //  justify="center"
      //    alignItems="flex-start"
       //   xs={12}
          >
          <Grid item xs={12} md={9}>
            <Grid container  spacing={8}>
            {value === 0 && <React.Fragment>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Gallerie />
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <PrestationsResume/>

                 </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paperDescription}>
                  <Typography component="p" className={classes.description}>
                    Idéalement située dans un quartier résidentiel calme et discret, proche des commerces, de la plage et de la digue.
                  </Typography>
                  <br/>
                  <Typography component="p" className={classes.description}>
                    Entièrement rénovée et équipée tout confort, la villa comprend au rdc une entrée, WC indépendants, cuisine indépendante avec bar et coin salle à manger, jardin d'hiver, salon-séjour avec TV, lecteur DVD, table à manger convertible en billard; au 1er étage WC indépendants, salle de bain avec baignoire et cabine de douche, chambre avec TV 3D et couchage double (160x200), chambre avec 2 couchages simples (90x200); au 2nd étage salle d'eau avec douche et WC, chambre avec TV et couchage double (160x200), chambre avec 2 couchages simples (90x200), petite chambre avec un couchage simple (90x200). Jardin clos et garage fermé.
                  </Typography>
                  <br/>
                  <Typography component="p" className={classes.description}>
                    Pour les tout-petits : lit bébé, chaise bébé, poussette, baignoire bébé, pot, réducteur WC.
                 </Typography>
                 <br/>
                  <Typography component="p" className={classes.description}>
                   Internet Wifi
                  </Typography>
                </Paper>
              </Grid>
              </React.Fragment>}
              {(/*value === 0 || */value === 1 ) && 
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Equipements/>
                </Paper>
              </Grid>
              }
              {(/*value === 0 || */value === 2 ) && 
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Tarif/>
                </Paper>
              </Grid>
              }
              {(/*value === 0 ||*/ value === 3 ) && 
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Localisation/>
                </Paper>
              </Grid>
              }
               {(/*value === 0 ||*/ value === 4 ) && 
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <PageFAQ/>
                </Paper>
              </Grid>
              }
            </Grid>

          </Grid>
          
          <Grid item xs={12} md={3}>
            <Paper className={classes.paperCalendar}>
              <Calendrier/>
            </Paper>
          </Grid>
        </Grid>
        

      </div>
    );
  }
};

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Main); //withStyle creates a new component with classes property



// WEBPACK FOOTER //
// ./src/Main.js